import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { IPlannerEventModel } from "../models/plannerEventModel";
import { constructPlannerEventHref } from "../../../../common/infrastructure/routes/routePaths";
import { getInfoToast } from "../../../../common/infrastructure/utilities/toastUtility";

export const LOCKED_EVENT_MESSAGE =
  "Само инструкторът на класа може да отвори детайлите.";

// One toast however many times a locked class is tapped.
const LOCKED_EVENT_TOAST_ID = "planner-locked-event";

/**
 * Opens a class from the planner list. A locked class (another instructor's, for an
 * employee with "can't open others' classes") explains itself instead, so a tap that
 * does nothing doesn't look broken.
 */
export const usePlannerEventClick = () => {
  const navigate = useNavigate();

  const onEventClick = useCallback(
    (item: IPlannerEventModel) => {
      if (item.isLocked) {
        getInfoToast(LOCKED_EVENT_MESSAGE, LOCKED_EVENT_TOAST_ID);
        return;
      }

      navigate(constructPlannerEventHref(item.id));
    },
    [navigate]
  );

  return { onEventClick };
};
